import { API } from "api";

export const getformStepListAPI = () => {
    return API.get("api/formStep/getall?page=0&size=0")
                .then((res) => res);
};

